"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFHTrendStatus = exports.includeOpenPositionStatus = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
exports.includeOpenPositionStatus = [
    TradeAPILib_1.OrderInnerStatus.initGrid,
    TradeAPILib_1.OrderInnerStatus.resuming,
    TradeAPILib_1.OrderInnerStatus.pausing,
    TradeAPILib_1.OrderInnerStatus.adjustInitGrid,
    TradeAPILib_1.OrderInnerStatus.adjustParamsInitGrid,
];
const useGFHTrendStatus = (props) => {
    const { symbolInfo, extraTipHeight, order, directionPrefix = "", isFocus, $st } = props;
    const baseDisplay = (0, react_1.useMemo)(() => {
        return symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay;
    }, [symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay]);
    const statusInfo = (0, react_1.useMemo)(() => {
        return order
            ? {
                trend: order.trend,
                earnCoin: order.earnCoin,
                row: order.number - 1,
                baseAmount: trade_utils_lib_1.NumberCommonUtils.toNormalPrice(order.baseAmount),
                quoteAmount: trade_utils_lib_1.NumberCommonUtils.toNormalPrice(order.quoteAmount),
                // needLoan: false,
                isConditionAndNotTriggered: order.isConditionAndNotTriggered,
                loanCoin: "",
                convertCoin: order.convertCoin,
            }
            : undefined;
    }, [order]);
    const cancelOrderInfo = (0, react_1.useMemo)(() => {
        if (!order) {
            return undefined;
        }
        if (new trade_utils_lib_1.SafeDecimal(order.filledOrdersAmount).eq(0)) {
            return {
                total: order.transactionAmount,
            };
        }
        return {
            total: new trade_utils_lib_1.SafeDecimal(order.transactionAmount).minus(new trade_utils_lib_1.SafeDecimal(order.filledOrdersAmount)).toNumber(),
        };
    }, [order]);
    const [openCount, setOpenCount] = (0, react_1.useState)(1);
    const [closeCount, setCloseCount] = (0, react_1.useState)(1);
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            var _a, _b;
            if (!isFocus) {
                return;
            }
            if (order) {
                if (order.innerStatus === undefined) {
                    return;
                }
                if (exports.includeOpenPositionStatus.some((a) => a === order.innerStatus)) {
                    if (openCount + 1 >= ((_a = statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.row) !== null && _a !== void 0 ? _a : 0)) {
                        setOpenCount(openCount);
                    }
                    else {
                        setOpenCount(openCount + 1);
                    }
                }
                if (order.innerStatus === TradeAPILib_1.OrderInnerStatus.destroyGrid || order.innerStatus === TradeAPILib_1.OrderInnerStatus.pausing) {
                    if (closeCount + 1 >= ((_b = cancelOrderInfo === null || cancelOrderInfo === void 0 ? void 0 : cancelOrderInfo.total) !== null && _b !== void 0 ? _b : 0)) {
                        setCloseCount(closeCount);
                    }
                    else {
                        setCloseCount(closeCount + 1);
                    }
                }
            }
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, [cancelOrderInfo === null || cancelOrderInfo === void 0 ? void 0 : cancelOrderInfo.total, closeCount, isFocus, openCount, order, order === null || order === void 0 ? void 0 : order.innerStatus, statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.row]);
    (0, react_1.useEffect)(() => {
        if (order && order.innerStatus === TradeAPILib_1.OrderInnerStatus.running) {
            setOpenCount(1);
        }
    }, [order, order === null || order === void 0 ? void 0 : order.innerStatus]);
    const limitPrice = (0, react_1.useMemo)(() => {
        let res = "--";
        if (order && statusInfo) {
            if (statusInfo.trend === TradeAPILib_1.GridFuturesTrend.long) {
                if (order.openPositionBuyLimit) {
                    res = trade_utils_lib_1.NumberCommonUtils.toFix(order.openPositionBuyLimit, symbolInfo && symbolInfo.precision ? symbolInfo.precision : 4);
                }
            }
            else {
                if (order.openPositionSellLimit) {
                    res = trade_utils_lib_1.NumberCommonUtils.toFix(order.openPositionSellLimit, symbolInfo && symbolInfo.precision ? symbolInfo.precision : 4);
                }
            }
        }
        return res;
    }, [order, statusInfo, symbolInfo]);
    const progressInfo = (0, react_1.useMemo)(() => {
        let res = {
            value: 0,
            content: "",
            showProgress: false,
        };
        if (order) {
            let progressInterval = 0.25;
            let closeInterval = 0.33;
            if (order.innerStatus !== undefined) {
                if (order.state === TradeAPILib_1.ExchangeOrderStatus.submitted) {
                    switch (order.innerStatus) {
                        case TradeAPILib_1.OrderInnerStatus.prepare:
                        case TradeAPILib_1.OrderInnerStatus.lockCurrency: {
                            if (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.isConditionAndNotTriggered) {
                                res = {
                                    value: progressInterval,
                                    content: directionPrefix + $st("grid_pro_open_order_content1"),
                                    showProgress: false,
                                };
                            }
                            else {
                                res = {
                                    value: progressInterval,
                                    content: directionPrefix + $st("grid_pro_open_order_content1"),
                                    showProgress: true,
                                };
                            }
                            break;
                        }
                        case TradeAPILib_1.OrderInnerStatus.conditionLock: {
                            if (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.isConditionAndNotTriggered) {
                                res = {
                                    value: progressInterval * 2,
                                    content: directionPrefix + $st("grid_pro_open_order_content2", { value: statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.loanCoin }),
                                    showProgress: false,
                                };
                            }
                            else {
                                res = {
                                    value: progressInterval * 2,
                                    content: directionPrefix + $st("grid_pro_open_order_content3"),
                                    showProgress: true,
                                };
                            }
                            break;
                        }
                        case TradeAPILib_1.OrderInnerStatus.openPosition: {
                            const content = (() => {
                                if ((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.symbolType) === trade_utils_lib_1.ExchangeSymbolType.future_perpetual) {
                                    return (directionPrefix +
                                        $st("grid_pro_open_order_content4_1_3", {
                                            base: baseDisplay,
                                            count: new trade_utils_lib_1.SafeDecimal(statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.baseAmount).toString(),
                                            price: limitPrice,
                                            quote: order.quote,
                                        }));
                                }
                                switch (symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.symbolType) {
                                    case trade_utils_lib_1.ExchangeSymbolType.leveraged_coin:
                                        return (directionPrefix +
                                            $st("grid_pro_open_order_content4_1", {
                                                base: baseDisplay,
                                                count: statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.baseAmount.toString(),
                                            }));
                                    default:
                                        return (directionPrefix +
                                            $st("grid_pro_open_order_content4_1_1", {
                                                base: baseDisplay,
                                                count: statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.baseAmount.toString(),
                                                price: limitPrice,
                                                quote: order.quote,
                                            }));
                                }
                            })();
                            res = {
                                value: progressInterval * 3,
                                content: content,
                                showProgress: true,
                            };
                            break;
                        }
                        case TradeAPILib_1.OrderInnerStatus.initGrid: {
                            res = {
                                value: progressInterval * 4,
                                content: directionPrefix +
                                    $st("grid_pro_open_order_content5", {
                                        current: openCount.toString(),
                                        total: statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.row,
                                    }),
                                showProgress: true,
                            };
                            break;
                        }
                    }
                }
                if (order.state === TradeAPILib_1.ExchangeOrderStatus.canceling) {
                    switch (order.innerStatus) {
                        case TradeAPILib_1.OrderInnerStatus.destroyGrid: {
                            res = {
                                value: closeInterval,
                                content: directionPrefix +
                                    $st("grid_pro_cancel_order_content1", {
                                        current: closeCount,
                                        total: cancelOrderInfo === null || cancelOrderInfo === void 0 ? void 0 : cancelOrderInfo.total,
                                    }),
                                showProgress: true,
                            };
                            break;
                        }
                        case TradeAPILib_1.OrderInnerStatus.closePosition: {
                            if (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.convertCoin) {
                                if ((statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.earnCoin) === order.quote) {
                                    res = {
                                        value: closeInterval * 2,
                                        content: directionPrefix +
                                            $st("grid_pro_cancel_order_content3_1", {
                                                base: baseDisplay,
                                                count: statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.baseAmount,
                                            }),
                                        showProgress: true,
                                    };
                                }
                                else {
                                    res = {
                                        value: closeInterval * 2,
                                        content: directionPrefix +
                                            $st("grid_pro_cancel_order_content3_2", {
                                                base: baseDisplay,
                                                count: statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.quoteAmount,
                                                quote: order.quote,
                                            }),
                                        showProgress: true,
                                    };
                                }
                            }
                            else {
                                res = {
                                    value: closeInterval * 2,
                                    content: directionPrefix + $st("grid_pro_cancel_order_content4"),
                                    showProgress: true,
                                };
                            }
                            break;
                        }
                    }
                }
            }
        }
        return res;
    }, [
        order,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.isConditionAndNotTriggered,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.loanCoin,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.baseAmount,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.row,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.convertCoin,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.earnCoin,
        statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.quoteAmount,
        directionPrefix,
        $st,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.symbolType,
        baseDisplay,
        limitPrice,
        openCount,
        closeCount,
        cancelOrderInfo === null || cancelOrderInfo === void 0 ? void 0 : cancelOrderInfo.total,
    ]);
    const _extraTipHeight = (0, react_1.useMemo)(() => {
        return extraTipHeight || 0;
    }, [extraTipHeight]);
    return {
        progressInfo,
        _extraTipHeight,
    };
};
exports.useGFHTrendStatus = useGFHTrendStatus;
